<template>
<div>
      <span class="material-symbols-outlined text-red-500 md-24" v-if="!booleandata">do_not_disturb_on</span>
      <span class="material-symbols-outlined  text-green-500 md-24" v-if="booleandata">check_circle</span>
</div>
</template>

<script>
export default {

  name: 'PlannerTableBooleanAttribute',
  props:["customattributefilters","column_id","column_data"],
  data () {
    return {

    }
  },
  computed:{
  	booleandata()
  	{
  		
  		if(this.column_id && this.column_data && this.customattributefilters)
  		{
  			let the_column = this.customattributefilters.find(item=>item.id == this.column_id)
  			let data = this.column_data[this.column_id+"_boolean"]
				if(data)
				{
					return data
				}
				return null
  		}
  		return null
  	},
  }
}
</script>

<style lang="css" scoped>
</style>